import * as React from 'react';
import * as update from 'immutability-helper';
import { is } from 'immutable';
import formatter from 'common/utils/formatter';
interface ImageProps {
    url: {
        [key: string]: string;
    };
    alt?: string;
    fallbackUrl?: string;
    className?: string;
    style?: Object;
    extension?: Function;
}

interface ImageState {
    urls: {
        [key: string]: string;
    };
    active: string;
}

export default class Image extends React.Component<ImageProps, ImageState> {
    private pending: Array<string> = [];

    constructor(props: ImageProps) {
        super(props);
        const { url } = props;
        this.state = this.getImageConfig(url);
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        !is(nextProps.url, this.props.url) && this.setState(this.getImageConfig(nextProps.url));
    }

    /**
     * 整合图片配置
     * @param url
     * @returns {{urls: {url: string} | {}; active: string}}
     */
     getImageConfig = (url: any) => {
        const urls = JSON.parse(JSON.stringify(this.getInitialUrls(url)));
        urls.aws = formatter.contact.relativeUrl(urls.aws);
        // aws排到第一位
        this.pending = Object.keys(urls).sort(item => item === 'aws' ? -1 : 1);
        return {
            urls,
            active: this.getPendingUrlKey()
        };
    };

    /**
     * 兼容不同类型的url参数
     * @param url
     * @returns {{url: string} | {}}
     */
    getInitialUrls = (url: any) => {
        if (url) {
            if ((typeof (url) === 'string')) {
                return { aws: formatter.contact.relativeUrl(url) };
            } else {
                return url.url ? url.url : url;
            }
        } else {
            return {};
        }
    };

    /**
     * 更新图片key
     * @returns {string}
     */
    getPendingUrlKey = () => {
        if (this.pending.length) {
            const active = this.pending[0];
            this.pending = update(this.pending, {
                $splice: [
                    [0, 1]
                ]
            }) as any;
            return active;
        }
    };

    /**
     * 切换图片链接
     */
    errorHandler = () => {
        if (this.pending.length) this.setState({ active: this.getPendingUrlKey() });
    };

    render() {
        const { alt, fallbackUrl, className, style } = this.props;
        const { urls, active } = this.state;
        let src = urls[active] || fallbackUrl;
        return (
            <img className={className} src={src} alt={alt} onError={this.errorHandler} style={style}/>
        );
    }
}
